  
function loadThesis(view) {
    return () => import( /* webpackChunkName: "thesis-[request]" */ `../components/Thesis/${view}.vue`)
}
function loadViewYudisium(view) {
    return () => import( /* webpackChunkName: "activities-[request]" */ `../views/Yudisium/${view}.vue`)
}
const route = [
    {
        path: '/thesis/mahasiswa',
        name: 'Pendaftaran Tugas Akhir',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['mahasiswa']
        },
        component: loadThesis('RegistrationView')
    },
    {
        path: '/thesis/verification',
        name: 'Verifikasi Tugas Akhir',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kaprodi','sekprodi','dosen','kadep','wadek','kalab']
        },
        component: loadThesis('VerifyRegistration')
    },
    {
        path: '/thesis/exam/:id',
        name: 'Exam Thesis',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadThesis('ExamRegistrationView')
    },
    {
        path: '/thesis-tester',
        name: 'Thesis Tester Verify',
        meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['kaprodi','sekprodi','dosen','kadep','wadek','laboran','kalab']
        },
        component: loadThesis('ExamTesterVerification')
    },
    {
        path: '/thesis-approval',
        name: 'Thesis Approval',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['laboran','wadek','kalab']
        },
        component: loadThesis('ExamApprovalView')
    },
    {
        path: '/thesis-exam-confirmation',
        name: 'Thesis Exam Value Confirmation',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['administrator']
        },
        component: loadThesis('ExamRegisterConfirmation')
    },
    {
        path: '/yudisium',
        name: 'Yudisium',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['administrator']
        },
        component: loadThesis('ExamRegisterYudisiumConfirmation')
    },
    {
        path: '/yudisium/all',
        name: 'Yudisium All',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['administrator']
        },
        component: loadThesis('ExamRegisterYudisiumHistory')
    },
    {
        path: '/thesis-exam',
        name: 'Thesis Exam Register',
        meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['kaprodi','sekprodi','administrator','dosen','kadep','wadek','laboran','kalab']
        },
        component: loadThesis('ExamRegister')
    },
    {
        path: '/thesis-exam/schedule/:id',
        name: 'Thesis Exam Schedule',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kaprodi','sekprodi','dosen','kadep','wadek','kalab']
        },
        component: loadThesis('ExamSchedule')
    },
    {
        path: '/thesis-exam/tester/:id',
        name: 'Thesis Exam Tester',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kaprodi','sekprodi','dosen','kadep','wadek','kalab']
        },
        component: loadThesis('ExamTester')
    },
    {
        path: '/thesis-exam/approval/:id',
        name: 'Thesis Exam Approval',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadThesis('ApprovalProgress')
    },
    {
        path: '/thesis-exam/revission/:id',
        name: 'Thesis Exam Revission',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadThesis('ResultAndRevissionStudent')
    },
    {
        path: '/thesis-revission/message/:id',
        name: 'Thesis Exam Revission Message',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadThesis('ExamRubricMessage')
    },
    {
        path: '/thesis-exam/attendance/:id',
        name: 'Thesis Exam Attendance',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kaprodi','sekprodi','dosen','kadep','wadek','kalab']
        },
        component: loadThesis('ExamAttendance')
    },
    {
        path: '/thesis-exam/report/:id',
        name: 'Thesis Exam Report',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadThesis('ExamReport')
    },
    {
        path: '/thesis-exam/rubric/:type/:id',
        name: 'Thesis Exam Rubric',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: ['kaprodi','sekprodi','dosen','kadep','wadek','kalab']
        },
        component: loadThesis('ExamRubric')
    },
    {
        path: '/thesis-rubric',
        name: 'ThesisRubricCategory',
        meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['kaprodi','sekprodi']
        },
        component: loadThesis('RubricCategory')
    },
    {
        path: '/thesis-rubric/:categoryId',
        name: 'ThesisRubricField',
        meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['kaprodi','sekprodi']
        },
        component: loadThesis('RubricField')
    },
    {
        path: '/thesis-change-topic',
        name: 'Ajuan Perubahan Topik',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kaprodi','sekprodi']
        },
        component: loadThesis('VerifyThesisChangeTopic')
    },
    {
        path: '/thesis-change-topic/:id',
        name: 'ChangeTopic',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kaprodi','sekprodi','mahasiswa']
        },
        component: loadThesis('ThesisChangeTopicView')
    },
    {
        path: '/skl-student',
        name: 'SklStudent',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['mahasiswa','ortu']
        },
        component: loadViewYudisium('SklStudent')
    },
    {
        path: '/skl-student-list',
        name: 'SklStudentList',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['administrator']
        },
        component: loadViewYudisium('SklStudentList')
    },
]

export default route